import { render, staticRenderFns } from "./DecimalFilter.vue?vue&type=template&id=0194b548&"
import script from "./DecimalFilter.vue?vue&type=script&lang=ts&"
export * from "./DecimalFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports